import { useState } from 'react';
import Parker from '../Entities/Parker';
import { queryUpdateParkerAccessSystemStatus } from '../Queries/Parker';
import featureFlags from '../featureFlags'

const parkerQueryFields = [
  'id',
  'suspension_status',
  'termination_status',
  'access_system_status',
  'rate_id'
]

function useReactivateAccessSystem(parkerId, callback) {
  const [ errorMessage, setErrorMessage ] = useState(null);
  const [ inProgress, setInProgress ] = useState(false);
  
  const reactivateAccessSystem = async () => {

    setInProgress(true);
    setErrorMessage(null);
    try {
      const { data, errors } = await queryUpdateParkerAccessSystemStatus({
        parker_id: parkerId,
        access_system_status: Parker.ACCESS_SYSTEM_STATUS.ON
      }, parkerQueryFields);

      if (errors) {
        throw new Error(errors.map(({ message }) => message));
      }

      const { status, suspension_status, termination_status, access_system_status, termination_date, rate_id } = data.updateParkerAccessSystemStatus;
      
      callback({ suspension_status, termination_status, access_system_status, termination_date, rate_id });
      
      
    } catch (error) {
      setErrorMessage(error.message);
    } finally {
      setInProgress(false);
    }
  }

  return {
    inProgress,
    setInProgress,
    errorMessage,
    reactivateAccessSystem
  };
}

export default useReactivateAccessSystem;